import { MILLISECOND } from "../../features/utils/globalVars";

/**
 * Function for rounding down based on MILLISECOND
 */
const getRoundedNum = (num: number) => {
  if (num % MILLISECOND === 0) {
    return num;
  }
  return num - (num % MILLISECOND);
};

export default getRoundedNum;
